import { useEffect } from "react";
import { cleanupStaleHoldsGlobally }        from "../components/booking/firebase/holds";
import { cleanupStaleReservationsGlobally } from "../components/booking/firebase/reservationCleanup";

// Re-run every 5 minutes. This just controls how often the stale-hold /
// stale-reservation sweep runs - the actual expiry lengths live in
// TTL.HOLD_MS and TTL.RESERVATION_MS in src/theme.js.
const CLEANUP_INTERVAL_MS = 5 * 60 * 1000;

export function useBackgroundCleanup() {
  useEffect(() => {
    async function runCleanup() {
      try {
        await cleanupStaleHoldsGlobally();
      } catch (err) {
        console.warn("[cleanup] holds sweep failed (non-critical):", err);
      }
      try {
        await cleanupStaleReservationsGlobally();
      } catch (err) {
        console.warn("[cleanup] reservations sweep failed (non-critical):", err);
      }
    }

    runCleanup();
    const id = setInterval(runCleanup, CLEANUP_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);
}